export enum TemperatureValues {
  spicy = 'spicy',
  cool = 'cool',
  hot = 'hot',
  warm = 'warm',
  vanilla = 'vanilla',
}

export enum BillingCodes {
  ultimateAnnual = 'ultimate_annual',
  ultimateMonth = 'ultimate_m2m',
  ultimateComped = 'ultimate_comped',
  premiumAnnual = 'premium_annual',
  premiumMonth = 'premium_m2m',
  premiumMonthlyAt1499 = 'premium_m2m_1499',
  premiumComped = 'premium_comped',
  premiumAnnualAt1799 = 'premium_annual_17990',
  premiumAnnualAt1499 = 'premium_annual_14990',
  premiumMonthSave10 = 'premium_m2m_save_10',
  premiumMonthSave15 = 'premium_m2m_save_15',
  premiumMonthDiscount15 = 'premium_m2m_special_discount_15',
  essentialMonth = 'essential_m2m',
  essentialAnnual = 'essential_annual',
  essentialComped = 'essential_comped',
  registration = 'registration',
}

export enum PlanCode {
  Ultimate = 'ULTIMATE',
  Premium = 'PREMIUM',
  Essential = 'ESSENTIAL',
  Free = 'FREE',
}

export enum MediaPurchase {
  alacarte = 'a_la_carte',
}
